import React, {useContext, useEffect, useRef, useState} from 'react';
import './CheckoutButton.less';

import {Button} from 'elements/button/Button';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const CheckoutButton = ({totalPrice, onClick, isEmpty}) => {
	const translations = useContext(TranslationsContext);

	const [isBouncing, setIsBouncing] = useState(false);
	const didMountRef = useRef(false);

	useEffect(() => {
		if (!didMountRef.current) {
			didMountRef.current = true;
			return;
		}

		setIsBouncing(true);
		setTimeout(() => {
			setIsBouncing(false);
		}, 500);

	}, [totalPrice]);

	return (
		<Button onClick={onClick} isDisabled={isEmpty}>
			<div className={`checkout-button  ${isBouncing ? 'checkout-button--bouncing' : ''}`}>
        <span className="checkout-button__caption">{
					isEmpty
						? getSafeTranslation('CheckoutButton.emptyCartButtonCaption', translations)
						: getSafeTranslation('CheckoutButton.buttonCaption', translations)
				}</span>
				<span className="checkout-button__price">{totalPrice}</span>
			</div>
		</Button>
	);
};
